export default __webpack_public_path__ + "static/appright-d2b64b7195b96b23d0718f7e87ed80e9.png";